import React from "react";
import { SurveyAnswers, SurveyResponses } from "../../../../common/hooks/api/useSurvey";
import { Organization } from "../../../../common/models";
import { CollectionGroupDetailsDto } from "../../../../common/service/server/dto/CollectionGroupDto";
import { DataMapDto } from "../../../../common/service/server/dto/datamap/DataMapDto";
import { SurveyGateButton } from "../survey/SurveyGateButton";
import { EmploymentGroupPurposesQuestion } from "./EmploymentGroupPurposesQuestion";
import { useFilteredPicGroups } from "./ConsumerDataCollectionCheckboxes";
import { CollectionCheckboxes } from "../../get-compliant/collection-groups/CollectionCheckboxes";

export const EmployeeDataCollectionForm: React.FC<{
  dataMap: DataMapDto;
  org: Organization;
  collectionGroup: CollectionGroupDetailsDto;
  answers: SurveyResponses;
  setAnswer: (slug: string, answer: string, question?: string) => Promise<SurveyAnswers | void>;
  collected?: string[];
  pending?: string[];
}> = ({ answers, setAnswer, dataMap, org, collectionGroup, collected, pending }) => {
  const orgId = org.id;

  const filteredPicGroups = useFilteredPicGroups({ dataMap, org, orderingVariant: "employee" });

  return (
    <>
      <CollectionCheckboxes
        group={collectionGroup}
        orgId={orgId}
        categoryGroups={filteredPicGroups}
        collected={collected}
        pending={pending}
      />

      <SurveyGateButton
        slug="emp-common-done"
        survey={answers}
        updateResponse={setAnswer}
        label="Done"
      >
        <EmploymentGroupPurposesQuestion employeeGroup={collectionGroup} />
      </SurveyGateButton>
    </>
  );
};
